function loadScript(scriptElement) {
    return function onTimeout() {
        document.head.appendChild(scriptElement);
    };
}

function isJsonScript(type) {
    return type.startsWith("application/") && type.endsWith("json");
}

function evaluateScript(script) {
    const type = (script.type || "").toLowerCase();

    if (type === "video-content" || isJsonScript(type)) {
        return;
    }

    const scriptClone = document.createElement("script");

    if (script.src) {
        scriptClone.setAttribute("src", script.src);
    } else {
        scriptClone.textContent = script.innerText;
    }

    setTimeout(loadScript(scriptClone), 1);
}

export default function evaluateLoadedScripts(container) {
    container.querySelectorAll("script").forEach(evaluateScript);
}
